import Vue from 'vue'
import { Logger } from "aws-amplify"
// import moment from "moment"
const logger = new Logger("$store/presence/mutations") 
import { offsetToSeconds } from "@/utils"

export default {
  setVehicleStatus: (state, item) => {
    Vue.set(state.vehicleStatus, item.VehicleID, item.status)
  },

  /*
  // updates the device info with details sent in the presence websocket events
  updateDevicePresence: (state, device) => {
    // if we already have some state for this device, we check here to see if the last seen time is more up to date that what we already have. 
    if(state.devicesMap[device.id]) {
        const currentLastSeen = moment(state.devicesMap[device.id].last_seen).valueOf()
        const newLastSeen = moment(device.last_seen).valueOf()
        if(currentLastSeen > newLastSeen) {
            logger.debug("pres update is older than current")
            return
        }
        
        state.devicesMap[device.id] = device
        state.vehicleStatus[device.vehicle_id] = device.statusText
    } else {
      //Vue.set(state.devicesMap, device.id, device)
      //Vue.set(state.vehicleStatus, device.vehicle_id, device.statusText)
    }

    //state.mapUpdatesToSend = true
  },
  */

  // bulk set the first states
  setDefaultPresences: (state, devices) => {
    Vue.set(state, "devicesMap", devices)
    const vehiclestats = {}
    Object.keys(devices).forEach(key => {
      vehiclestats[devices[key].vehicle_id] = devices[key].statusText
    })
    Vue.set(state, "vehicleStatus", vehiclestats)    
    //state.mapUpdatesToSend = true
  },
  
  /*
  mapUpdatesSent: function (state) {
    state.mapUpdatesToSend = false
  },
  */

  /**
   * We run this function every 15 seconds from WebSocket.vue
   * 
   * We can potentially recieve a large ammount of websocket updates to devices and we want to avoid recalculating any computed properties or UI elements 
   * everytime one of these updates come in. 
   * 
   * To handle this, we have holding states that we use to store the websocket changes as they come in, and then update our watched state every 15 
   * seconds with this function
   */
  updateMapData: function (state, options) {
    logger.debug("### updatemapdata", options)
    state.devicesMap = options.devicesMapHolding
    state.vehicleStatus = options.vehicleStatusHolding
    const devices = Object.values(options.devicesMapHolding)
    const vehiclesSet = state.vehicles.reduce((set, item) => {
      set[item.id] = {
        vehicle_name: item.vehicle_name,
        vehicle_type: item.vehicle_type
      }
      return set
    }, {}) 
    const currentStates = state.vehicles.map(veh => {
      const vehicle_id = veh.id
      // we need to consider here how we decide which device to use, most recent last seen time seems most appropriate
      const options = devices.filter(d => d.vehicle_id == vehicle_id).sort((a, b) => b.data.mileage - a.data.mileage)

      //logger.debug(vehicle_id, options)
      let record = options.length ? options[0] : false

      if(record) {   
        record.name = vehiclesSet[vehicle_id].vehicle_name
        record.type = vehiclesSet[vehicle_id].vehicle_type.toLowerCase() 
        record.name = record.name && record.name.length 
          ? record.name.trim()
          : 'unknown'
        
        record.driver = state.vehicleDrivers[vehicle_id] || ''
        record.label = record.driver 
          ? `${record.driver} - ${record.name}`
          : record.name
      }

      return record
    })

    state.mapData = currentStates.filter(i => i) // remove any vehicles without devices, we can't show these on the map view
  },

  setVehicleDriver: (state, item) => {
    logger.debug(`assigned driver ${item.DriverName} to ${item.VehicleID}`)
    Vue.set(state.vehicleDrivers, item.VehicleID, item.DriverName)
  },

  setVehicles: (state, vehicles) => {
    state.vehicles = vehicles
  },

  setSpotlight: (state, item) => {
    logger.debug(`assigned driver ${item.id} to ${item.value}`)
    Vue.set(state.spotlight, item.id, item.value)
    //.mapUpdatesToSend = true // we want to tell the mapview we have updates to send now
  },

  resetSpotlight: (state) => {
    state.spotlight = {}
    state.spotlightResetCounter++
  },

  updateHistoricalDrivers: (state, drivers) => {
    // find our vehicle id
    try {
      drivers.forEach(assignment => {
        //function to remove white space from strings
        const cleanString = (str) => str.replace(/\s/g, '')

        const vehicle = state.vehicles.find(i => cleanString(i.vehicle_name) == cleanString(assignment.VehicleRegistrationNumber))

        if(vehicle) {
          // if we have no assignments, create an empty object for the vehicles
          if(!state.historicalDrivers[vehicle.id]) {
            state.historicalDrivers[vehicle.id] = {}
          }

          // set our start and end drivers
          let startstamp =  Number.parseInt(assignment.FromDateUnixTimestamp) - offsetToSeconds(assignment.Timezoneoffset)
          state.historicalDrivers[vehicle.id][startstamp] = assignment

          // if we do not have a new assignment when this assignment ends, we add a blank assignment
          if(assignment.ToDateUnixTimestamp.length && !state.historicalDrivers[vehicle.id][assignment.ToDateUnixTimestamp]) {
            let endstamp = Number.parseInt(assignment.ToDateUnixTimestamp) - offsetToSeconds(assignment.Timezoneoffset)
            state.historicalDrivers[vehicle.id][endstamp] = false
          }
        } else {
          logger.debug("could not find vehicle for historical assignment", assignment, state.vehicles.map(i => i.vehicle_name))
        }
      })
    } catch (ex) {
      logger.debug("could not update historical assignments", ex)
    }
  }
}